<template>
  <div class="ais-RefinementList">
    <h3
      v-if="showLabel"
      class="h6 muted text-uppercase"
      style="letter-spacing: var(--letter-spacing-2xl)"
    >
      Featured
    </h3>
    <ul
      class="icons-facets-group-editorial"
      style="--list-style-type: none; --padding-left: 0; --margin-top: 0; --margin-bottom: var(--spacing-2xl)"
    >
      <ais-toggle-refinement
        v-for="filter in filters"
        :key="filter.attribute"
        :attribute="filter.attribute"
        :label="filter.label"
        :on="true"
      >
        <li
          v-if="showFilter(value, filter)"
          slot-scope="{ value, refine }"
          class="wrap-icons-facet-input margin-bottom-5xs"
          :style="`${value.count == 0 ? 'display: none;' : ''}`"
        >
          <input
            :id="`icons-filter-${filter.attribute}`"
            type="checkbox"
            name="categories"
            class="with-icon"
            :checked="value.isRefined"
            @change="applyFacet(refine, value)"
          />

          <label
            :for="`icons-filter-${filter.attribute}`"
            class="icons-facet icons-facet-input margin-0 flex-row size-sm flex-items-baseline"
            style="padding: var(--spacing-2xs) var(--spacing-sm); cursor: pointer; display: flex !important"
          >
            <span class="icons-facet-affordance position-relative margin-right-sm">
              <font-awesome-icon
                :icon="$v6.solid[filter.icon]"
                fixed-width
                class="unchecked-icon"
              />
              <font-awesome-icon
                :icon="$v6.regular.faSquare"
                fixed-width
                class="hover-icon"
              />
              <font-awesome-icon
                :icon="$v6.solid.faSquareCheck"
                fixed-width
                class="checked-icon"
              />
            </span>

            <span style="flex-grow: 1; flex-shrink: 1; flex-basis: auto">
              <span class="sr-only">
                <template v-if="value.isRefined">Showing&nbsp;</template>
                <template v-else>Show&nbsp;</template>
              </span>
              <span class="text-capitalize">{{ filter.label }}</span>
              <span class="sr-only">&nbsp;icons</span>
            </span>

            <span
              v-if="value.count > 0"
              class="icons-facet-count margin-left-sm"
            >
              <span v-if="value.isRefined == false">{{ value.count.toLocaleString() }}</span>
              <span class="sr-only">matching results</span>
            </span>
          </label>
        </li>
        <li
          v-else
          style="display: none"
        />
      </ais-toggle-refinement>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'EditorialFacets',

    data() {
      return {
        showLabel: true,
        filters: [
          { shown: true, attribute: 'is_new_in_v6', label: 'New in v6', icon: 'faSparkles' },
          { shown: true, attribute: 'is_sponsored', label: 'Sponsored', icon: 'faCircleDollar' },
          { shown: true, attribute: 'is_staff_favorite', label: 'Staff Favorites', icon: 'faHeart' }
        ]
      }
    },

    computed: {
      activeVersion() {
        return this.$releases.active.versionParts.major
      }
    },

    methods: {
      showFilter(value, filter) {
        filter.shown = value.count > 0 && value.onFacetValue.count != null
        this.updateShowLabel()
        return filter.shown
      },

      updateShowLabel() {
        let show = false
        this.filters.forEach((filter) => {
          if (filter.shown) {
            show = true
          }
        })

        this.showLabel = show
      },

      applyFacet(refine, value) {
        refine(value)
        this.$emit('scrollTop')
        this.$emit('closeIcon')
        this.$posthog.capture('icon_search:editorial_facet_button_click', { facet: value.name })
      }
    }
  }
</script>
